import * as Yup from 'yup';
import { errorMessages } from '~/constants/errorMessages.js';

export const applicationReportsValidationSchema = Yup.object().shape({
  fromDate: Yup.string().required(errorMessages.FIELD_REQUIRED),
  toDate: Yup.string().required(errorMessages.FIELD_REQUIRED),
  status: Yup.object().nullable(),
  clientType: Yup.object().nullable(),
  applicationType: Yup.object().nullable(),
  lastUpdatedTo: Yup.string().nullable(),
  tobo: Yup.object().nullable(),
  initiatorType: Yup.object().nullable(),
  page: Yup.number().nullable(),
  size: Yup.number().nullable(),
});
